import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import Form from 'react-bootstrap/Form'
import { Button, Col, InputGroup, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { createLead } from '@/data/conn/post/order'
import { ReactGAEvent } from '@/components/ReactGAs'

const SpeakToUsForm = ({ type = '' }) => {
	const initialState = {
		user_name: '',
		mobile_number: '',
		location: '',
		turnover: '',
		message: type === 'recycling' ? [] : '',
		check: true,
		country_code: '+91',
	}
	const [formState, setFormState] = useState(initialState)
	const [step, setStep] = useState(1)

	const commodityList = [
		{ name: 'HMS Scrap' },
		{ name: 'Nickel' },
		{ name: 'Mixed Metals' },
		{ name: 'Zinc' },
		{ name: 'Magnesium' },
		{ name: 'Aluminium' },
		{ name: 'Lithium' },
		{ name: 'Cobalt' },
	]

	const clickGAHandler = () => {
		ReactGAEvent({ action: 'Form_get_in_touch', event: 'Form Submit', label: 'Form', category: 'Send in message' })
	}

	const submitHandler = (values) => {
		if (type === 'recycling') {
			let msg = values.message?.join(',')
			values = { ...values, message: msg }
		}
		values = { ...values, country_code: 'IN' }

		createLead({ ...values, lead_type: type })
			.then((res) => {
				setFormState(initialState)
			})
			.catch((err) => {
				console.log(err)
			})
			.finally(()=>{
				clickGAHandler()
			})

		// // move to second step
		setStep(2)
	}

	const onError = (error) => {}

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
	} = useForm({
		mode: 'onTouched',
		reValidateMode: 'onChange',
		defaultValues: formState,
	})

	useEffect(() => {
		const subscription = watch((value, { key, type }) => {})
		return () => subscription.unsubscribe()
	}, [watch])

	const privacyPolicy = () => {
		return (
			<div className='privacy-policy-wapper'>
				For information about how Metalbook handles personal data, see our{' '}
				<Link href='/privacy-policy' className='primary-text'>
					<span className='border-bottom border-danger'>Privacy Policy</span>
				</Link>
				.
			</div>
		)
	}

	return (
		<>
			{step === 1 && (
				<Form onSubmit={handleSubmit(submitHandler, onError)}>
					<Row className='my-3'>
						<Col xs={12} md={12} lg={6}>
							<Form.Group as={Col} controlId='exampleForm.ControlInput1'>
								<Form.Label className='speck-form-label'>Full name</Form.Label>
								<Form.Control
									{...register('user_name', { required: 'Please enter your full name' })}
									type='text'
									placeholder='Your name'
									className='shadow-sm speak-input'
								/>
								{errors.user_name && <Form.Text className='text-danger'>{errors.user_name.message}</Form.Text>}
							</Form.Group>
						</Col>
						<Col xs={12} md={12} lg={6}>
							<Form.Group as={Col} className='numeric-input' controlId='exampleForm.ControlInput2'>
								<Form.Label className='speck-form-label'>Mobile Number</Form.Label>
								<InputGroup>
									<Form.Control
										{...register('country_code', {
											maxLength: { value: 4, message: 'Country Code not valid' },
											pattern: { value: /^(\+?\d{1,3}|\d{1,4})$/, message: 'Enter a valid Country Code' },
											message: 'Enter valid phone number',
										})}
										placeholder='+91'
										autoComplete='off'
										className='w-25'
									/>
									<Form.Control
										maxLength={10}
										{...register('mobile_number', {
											required: 'Mobile number is required',
											pattern: {
												value: /^[6-9]\d{9}$/,
												message: 'Enter a valid 10-digit mobile number',
											},
										})}
										// type=''
										autoComplete='off'
										placeholder='999XXXXX98'
										className='shadow-sm speak-input w-75'
									/>
								</InputGroup>
								{errors.mobile_number ? (
									<Form.Text className='text-danger'>{errors.mobile_number.message}</Form.Text>
								) : errors.country_code ? (
									<Form.Text className='text-danger'>{errors.country_code.message}</Form.Text>
								) : (
									<></>
								)}
							</Form.Group>
						</Col>
					</Row>
					{type !== 'finance' && (
						<Form.Group className='mb-3 mt-3' controlId='exampleForm.ControlInput3'>
							<Form.Label className='speck-form-label'>Location</Form.Label>
							<Form.Control
								{...register('location')}
								type='text'
								placeholder='Enter your location...'
								className='shadow-sm speak-input'
								autoComplete='off'
							/>
						</Form.Group>
					)}
					{type === 'finance' && (
						<Form.Group className='mb-3 mt-3' controlId='exampleForm.ControlInput3'>
							<Form.Label className='speck-form-label'>{`Company Turnover (in Cr)`}</Form.Label>
							<Form.Control
								{...register('turnover', { required: type === 'finance' })}
								type='number'
								placeholder={`Enter your Company's turnover`}
								autoComplete='off'
							/>
						</Form.Group>
					)}
					{type !== 'recycling' ? (
						<Form.Group className='mb-3 mt-3' controlId='exampleForm.ControlTextarea1'>
							<Form.Label className='speck-form-label'>
								{type === 'fabrication'
									? 'Process Type'
									: type === 'selling'
									? 'Categories that you want to sell'
									: type === 'buying'
									? 'Tell us your Requirements'
									: type === 'recycling'
									? 'Commodities'
									: 'Message'}
							</Form.Label>
							<Form.Control
								{...register('message')}
								as='textarea'
								placeholder={
									type === 'fabrication'
										? 'Slitting, CTL ,etc.'
										: type === 'selling'
										? 'TMT bars, Pipes, Copper rods etc.....'
										: type === 'buying'
										? 'Interested categories, Total required quantity in MT etc.'
										: type === 'recycling'
										? 'Commodity you want to buy/sell'
										: 'Enter Message....'
								}
								rows={3}
								autoComplete='off'
								className='shadow-sm'
							/>
						</Form.Group>
					) : (
						<Form.Group className='mb-3 mt-3'>
							<Form.Label>Select Commodity you want to buy/sell</Form.Label>
							<Form.Group className='mt-2 d-flex col flex-wrap commodity-form-items'>
								{commodityList.map((item) => {
									return (
										<Col lg={3} md={5} xs={5} className='m-0'>
											<Form.Check
												// lg={3}
												type='text'
												className='speak-form-check'
												{...register('message')}
												value={item?.name}
												// onChange={() => {}}
												label={item?.name}
											/>
										</Col>
									)
								})}
							</Form.Group>
						</Form.Group>
					)}
					<Form.Group className='mb-3 mt-3' controlId='formBasicCheckbox'>
						<Form.Check
							type='checkbox'
							{...register('check', {
								required: 'You must agree before submitting',
							})}
							label={privacyPolicy()}
						/>
						{errors.check && <Form.Text className='text-danger'>{errors.check.message}</Form.Text>}
					</Form.Group>
					<Button variant='primary' className='border-0 w-100  mt-3' type='submit'>
						Send Message
					</Button>
				</Form>
			)}
			{step === 2 && (
				<div>
					<div className='d-flex mt-4'>
						<p className='fs-3 fw-bolder'>Thank you</p>
					</div>
					<div className='d-flex'>
						Your submission has been received. Our team will reach out to you within 48 hours with the quotations.
					</div>
				</div>
			)}
		</>
	)
}

export default SpeakToUsForm
